module.exports = __webpack_public_path__ + "89da329e9b9331e2df17fd43c6611822.fbx";